import React, { useState } from "react";
import { ReactComponent as AssestsIcon } from "../../assets/images/icons/Assests.svg";
import { ReactComponent as SpaceInfo } from "../../assets/images/icons/spaceInfo.svg";
import { ReactComponent as DeleteSpace } from "../../assets/images/icons/DeleteSpace.svg";
import { getHexWithOpacity, getTitleCase } from "../../utils/utilityFunctions/stringUtility";
import { getUserDateTime } from "../../utils/utilityFunctions/UTCFormat";
import ConfirmationDialogMulti from "../UniversalComponents/ConfirmationDialogMulti";
import { deleteTemplate } from "../../utils/api/customTemplatesApi";
import { MdDeleteSweep } from "react-icons/md";
import { HiInformationCircle } from "react-icons/hi";
import { TbEyeSearch } from "react-icons/tb";
import { IoIosLock } from "react-icons/io";
import HighlightedParagraph from "../UniversalComponents/HighlightedParagraph";
import ToolTipComponent from "../UniversalComponents/ToolTipComponent";
import { Dialog } from "@mui/material";
import { CgArrowsExpandRight } from "react-icons/cg";

const colors = [
  "#782AEE",

  "#DB4A6B",

  "#7A518E",

  "#C46D3A",

  "#813B3B",

  "#2F18DB",

  "#164A79",

  "#9B6F00",

  "#007E9A",

  "#134E30",

  "#EF4444",

  "#8C7A75",

  "#65657F",

  "#99031C",

  "#005D85",

  "#731B5B",

  "#DF2982",

  "#949E26",

  "#817D02",

  "#310082",

  "#9A0D94",

  "#310082",

  "#ED592E",

  "#3DB22A",

  "#80703F",

  "#D47A46",

  "#248B5B",

  "#26364C",
];

const TaskModuleSpace2 = ({ space, onClick, onDelete, index, globalFilter, selectedSpace }) => {
  const [open, setOpen] = useState(false);
  const handlePreviewOpen = (e) => {
    e.stopPropagation();
    setOpen((prev) => !prev);
  };
  return (
    <>
      <div
        className="flex w-[320px] h-60 flex-col overflow-y-auto justify-evenly gap-2 rounded-xl border border-gray-100 bg-white/80 px-6 py-4 cursor-pointer shadow hover:shadow-card hover:border-primary-hover"
        onClick={onClick}
      >
        {/* Header */}
        <div className="flex items-start justify-between">
          <div
            style={{
              background: `linear-gradient(to right, ${space?.color?.from || "#397AB8"} 0%, ${space?.color?.to || "#193652"} 100%)`,
            }}
            className="flex h-12 w-12 items-center justify-center rounded-xl text-white"
          >
            <i className={space?.icon || "bi bi-border-style text-white text-2xl"}></i>
          </div>
          <ToolTipComponent
            text={space?.is_locked ? "Locked" : "Hi I’m here to help you. I’m flexible with text"}
            darkMode
          >
            <div className="flex">
              {space?.is_locked ? (
                <IoIosLock className="h-6 w-6 text-[#13131333]" />
              ) : (
                <HiInformationCircle className="h-6 w-6 text-[#13131333]" />
              )}
            </div>
          </ToolTipComponent>
        </div>

        {/* name */}
        <div className="flex flex-col">
          <h3 className="text-base font-semibold leading-7 text-black/80">
            <HighlightedParagraph paragraph={getTitleCase(space?.template_name)} searchTerm={globalFilter} />
          </h3>
        </div>

        {/* description */}
        <div className="flex flex-col items-start justify-center text-[11px] gap-y-1 w-full">
          {space?.template_description && (
            <div className="flex items-center justify-between  min-w-0 pr-3 group">
              <span className="text-sm leading-[22px] text-black/60 ">
                <HighlightedParagraph
                  className="max-w-[33ch] truncate"
                  paragraph={space.template_description}
                  searchTerm={globalFilter}
                />
              </span>

              {space.template_description.length > 33 && (
                <ToolTipComponent text="Extend" darkMode>
                  <div
                    className="w-4 pl-1 cursor-pointer hidden group-hover:flex "
                    onClick={(e) => handlePreviewOpen(e)}
                  >
                    <CgArrowsExpandRight className="h-4 w-5 text-black/60 hover:text-primary shrink-0" />
                  </div>
                </ToolTipComponent>
              )}
            </div>
          )}
          {selectedSpace === "workspace" && (
            <div className="flex items-center justify-start gap-1 italic text-black/60">
              <span>Scope:</span>
              <span className="not-italic text-blue-500">
                <HighlightedParagraph
                  className="max-w-[10ch] truncate "
                  paragraph={getTitleCase(space?.scope)}
                  searchTerm={globalFilter}
                />{" "}
              </span>
            </div>
          )}
          <div className="flex items-start justify-between w-full">
            <div className="flex items-center justify-start gap-1 italic text-black/60">
              <span>Created by:</span>
              <span className="not-italic text-blue-500  ">
                <HighlightedParagraph
                  className="max-w-[10ch] truncate "
                  paragraph={getTitleCase(space?.created_by)}
                  searchTerm={globalFilter}
                />{" "}
              </span>
            </div>

            <span className="italic text-amber-900/70">
              <HighlightedParagraph
                paragraph={getUserDateTime(space?.created_at, "toLocal", "toUTC")}
                searchTerm={globalFilter}
              />{" "}
            </span>
          </div>
        </div>

        {/* Footer */}
        <div className="border-t border-black/10 pt-2">
          <div className="flex items-center justify-between">
            <span
              style={{
                background: space?.is_deployed
                  ? "linear-gradient(150deg, #3DB22A 0%, #1A4C12 100%)"
                  : "linear-gradient(150deg, rgba(156,163,175,0.3) 0%, rgba(0,0,0,0.3) 100%)",
              }}
              className="rounded px-3 py-1 text-[11px] font-400 text-white"
            >
              {space?.is_deployed ? "Deployed" : "Draft"}
            </span>

            {!space?.is_deployed && (
              <MdDeleteSweep
                className="h-6 w-7 cursor-pointer text-[#FC00054D] hover:text-[#fc00047e]"
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(space);
                }}
              />
            )}
          </div>
        </div>
      </div>
      {open && (
        <Dialog
          open={open}
          onClose={(e) => handlePreviewOpen(e)}
          PaperProps={{
            className: "w-[400px] h-[300px] max-w-none",
          }}
        >
          <div className="flex flex-col h-full w-full overflow-y-auto justify-between gap-2 pb-5 rounded-xl border border-gray-100 bg-white/80  shadow hover:shadow-card hover:border-primary-hover">
            <div className="w-full h-full flex flex-col items-center">
              {/* Header */}
              <div className="inline-flex w-full items-center justify-between rounded-t-md bg-white px-4 py-3 outline outline-1 outline-[#E9E9E9] -outline-offset-1">
                <div className="flex w-full items-center gap-2.5">
                  <div
                    style={{
                      background: `linear-gradient(to right, ${space?.color?.from || "#397AB8"} 0%, ${space?.color?.to || "#193652"} 100%)`,
                    }}
                    className="flex h-12 w-12 items-center justify-center rounded-xl text-white"
                  >
                    <i className={space?.icon || "bi bi-border-style text-white text-2xl"}></i>
                  </div>

                  {/* Content */}
                  <div className="flex flex-col">
                    <h3 className="text-base font-semibold leading-7 text-black/80">
                      <HighlightedParagraph
                        className="max-w-[30ch] truncate"
                        paragraph={getTitleCase(space?.template_name)}
                        searchTerm={globalFilter}
                      />
                    </h3>
                  </div>
                </div>

                <div className="flex items-start justify-center p-1.5">
                  <i
                    onClick={(e) => handlePreviewOpen(e)}
                    class="bi bi-x-lg h-4 w-4 text-[#868D96] cursor-pointer hover:text-[#444545]"
                  ></i>
                </div>
              </div>

              {/* Meta */}
              <div className="flex flex-col items-start justify-center text-[11px] gap-y-1 w-full py-2 px-3 min-h-0 grow">
                {space?.template_description && (
                  <span className="text-sm leading-[22px] text-black/60 min-h-0 grow overflow-y-auto">
                    <HighlightedParagraph paragraph={space.template_description} searchTerm={globalFilter} />
                  </span>
                )}

                <div className="flex items-start justify-between w-full">
                  <div className="flex items-center justify-start gap-1 italic text-black/60">
                    <span>Created by:</span>
                    <span className="not-italic text-blue-500  ">
                      <HighlightedParagraph
                        className="max-w-[10ch] truncate "
                        paragraph={getTitleCase(space?.created_by)}
                        searchTerm={globalFilter}
                      />{" "}
                    </span>
                  </div>

                  <span className="italic text-amber-900/70">
                    <HighlightedParagraph
                      paragraph={getUserDateTime(space?.created_at, "toLocal", "toUTC")}
                      searchTerm={globalFilter}
                    />{" "}
                  </span>
                </div>
              </div>
            </div>
            {/* Footer */}
            <div className="border-t border-black/10 pt-2 px-3">
              <div className="flex items-center justify-between">
                <span
                  style={{
                    background: space?.is_deployed
                      ? "linear-gradient(150deg, #3DB22A 0%, #1A4C12 100%)"
                      : "linear-gradient(150deg, rgba(156,163,175,0.3) 0%, rgba(0,0,0,0.3) 100%)",
                  }}
                  className="rounded px-3 py-1 text-[11px] font-400 text-white cursor-pointer"
                >
                  {space?.is_deployed ? "Deployed" : "Draft"}
                </span>

                {!space?.is_deployed && (
                  <MdDeleteSweep
                    className="h-6 w-7 cursor-pointer text-[#FC00054D] hover:text-[#fc00047e]"
                    onClick={(e) => {
                      e.stopPropagation();
                      onDelete(space);
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
};

export default TaskModuleSpace2;
